import { jsondan } from '../../FikoThreeType';
import { FikoGrup } from '../FikoGrup';
import { FikoKonumlar } from '../FikoKonumlar/FikoKonumlar';
import { FikoKaliciOlcumler } from '../FikoKaliciOlcumler';
import { FikoSahne } from '../FikoSahne';
import * as THREE from "three";

export class FikoKaynakca extends FikoGrup {
    override type: any = "FikoKaynakca";
    /** */
    sayac = 1;
    /** */
    konumlar: FikoKonumlar = new FikoKonumlar(this.sahne);
    kameraKontrolleri: FikoGrup;
    /** Kalıcı ölçümler grubu - dialog kapatılsa bile silinmez */
    kaliciOlcumler: FikoKaliciOlcumler;
    // isiklar: FikoGrup = new FikoGrup(this.sahne, "Işıklar")
    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/proje.webp";

        this.ekle(this.konumlar);

        // Kalıcı Ölçümler grubu oluştur
        this.kaliciOlcumler = new FikoKaliciOlcumler(this.sahne);
        this.ekle(this.kaliciOlcumler);

        // Kamera Kontrolleri grubu oluştur
        this.kameraKontrolleri = new FikoGrup(this.sahne, "Kamera Kontrolleri");
        this.kameraKontrolleri.userData['FikoArayuz'].agactaGorunur = true;
        this.kameraKontrolleri.userData['FikoArayuz'].listeGoster = false;
        this.kameraKontrolleri.userData['FikoArayuz'].simge = "./simgeler/kamera.webp";

        // 🎯 KULLANICI AYARLARI: Hassas kontrol için düşük başlangıç değerleri
        this.kameraKontrolleri.userData['FikoParametreler'] = [
            {
                isim: "Pan Hızı",
                turu: "Çubuk",
                ayar: {
                    min: 0.1,
                    maks: 10.0,
                    adim: 0.1
                },
                degeri: 0.2, // ✅ DÜŞÜRÜLDÜ: 5.0 → 0.2 (hassas kontrol)
                degisti: (yeniDeger: number) => {
                    if (this.sahne?.anaGosterim?.aktifKontrol) {
                        this.sahne.anaGosterim.aktifKontrol.panSpeed = yeniDeger;
                        this.sahne.anaGosterim.aktifKontrol._basePanSpeed = yeniDeger;
                        if (typeof this.sahne.anaGosterim.aktifKontrol.updateDynamicSpeeds === 'function') {
                            this.sahne.anaGosterim.aktifKontrol.updateDynamicSpeeds();
                        }
                    }
                }
            },
            {
                isim: "Döndürme Hızı",
                turu: "Çubuk",
                ayar: {
                    min: 0.1,
                    maks: 20.0,
                    adim: 0.1
                },
                degeri: 1.0, // ✅ DÜŞÜRÜLDÜ: 7.0 → 1.0 (hassas kontrol)
                degisti: (yeniDeger: number) => {
                    if (this.sahne?.anaGosterim?.aktifKontrol) {
                        this.sahne.anaGosterim.aktifKontrol.rotateSpeed = yeniDeger;
                        this.sahne.anaGosterim.aktifKontrol._baseRotateSpeed = yeniDeger;
                        if (typeof this.sahne.anaGosterim.aktifKontrol.updateDynamicSpeeds === 'function') {
                            this.sahne.anaGosterim.aktifKontrol.updateDynamicSpeeds();
                        }
                    }
                }
            },
            {
                isim: "Zoom Hızı",
                turu: "Çubuk",
                ayar: {
                    min: 0.1,
                    maks: 15.0,
                    adim: 0.1
                },
                degeri: 1.0, // ✅ DÜŞÜRÜLDÜ: 10 → 1.0 (hassas kontrol)
                degisti: (yeniDeger: number) => {
                    if (this.sahne?.anaGosterim?.aktifKontrol) {
                        this.sahne.anaGosterim.aktifKontrol.zoomSpeed = yeniDeger;
                    }
                }
            }
        ];

        // Başlangıç değerlerini uygula
        this.kameraKontrolleriBaslangicDegerleriniUygula();

        this.ekle(this.kameraKontrolleri);

        /** */

        /** */

        // let light = new THREE.DirectionalLight(0xffffff, 1);
        // this.add(light);
        // this.isiklar.ekle(light)

        // this.sahne.anaGosterim.aktifKontrol.addEventListener("change", (event: any) => {
        //     light.position.copy(sahne.anaGosterim.aktifKamera.position);
        //     light.matrix.copy(sahne.anaGosterim.aktifKamera.matrix);
        //     sahne.anaGosterim.ciz()
        // });


        // this.ekle(this.isiklar)
    }


    /** Kamera kontrolleri başlangıç değerlerini uygula */
    private kameraKontrolleriBaslangicDegerleriniUygula() {
        const parametreler = this.kameraKontrolleri.userData['FikoParametreler'];
        if (parametreler && this.sahne?.anaGosterim?.aktifKontrol) {
            parametreler.forEach((param: any) => {
                if (param.degeri !== undefined && typeof param.degisti === 'function') {
                    param.degisti(param.degeri);
                }
            });
        }
    }

    fromJson(json?: any) {
        this.konumlar.fromJson(json.konumlar)
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

        _rslt.konumlar = this.konumlar.toJSON();

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoKaynakca(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        _rslt.konumlar = jsondan(sahne, parent, json.konumlar);


        return _rslt;

    }
}